// カテゴリ色 — 決定的にハッシュしてパレットから割当。
// 既存カテゴリは固定色（覚えやすさ優先）、未知のカテゴリはハッシュから自動割当。

const PALETTE = [
  { bg: 'bg-sky-100', text: 'text-sky-800', border: 'border-sky-200', ring: 'ring-sky-300', dot: '#0ea5e9' },
  { bg: 'bg-violet-100', text: 'text-violet-800', border: 'border-violet-200', ring: 'ring-violet-300', dot: '#8b5cf6' },
  { bg: 'bg-emerald-100', text: 'text-emerald-800', border: 'border-emerald-200', ring: 'ring-emerald-300', dot: '#10b981' },
  { bg: 'bg-amber-100', text: 'text-amber-800', border: 'border-amber-200', ring: 'ring-amber-300', dot: '#f59e0b' },
  { bg: 'bg-rose-100', text: 'text-rose-800', border: 'border-rose-200', ring: 'ring-rose-300', dot: '#f43f5e' },
  { bg: 'bg-cyan-100', text: 'text-cyan-800', border: 'border-cyan-200', ring: 'ring-cyan-300', dot: '#06b6d4' },
  { bg: 'bg-lime-100', text: 'text-lime-800', border: 'border-lime-200', ring: 'ring-lime-300', dot: '#84cc16' },
  { bg: 'bg-fuchsia-100', text: 'text-fuchsia-800', border: 'border-fuchsia-200', ring: 'ring-fuchsia-300', dot: '#d946ef' },
  { bg: 'bg-orange-100', text: 'text-orange-800', border: 'border-orange-200', ring: 'ring-orange-300', dot: '#f97316' },
  { bg: 'bg-teal-100', text: 'text-teal-800', border: 'border-teal-200', ring: 'ring-teal-300', dot: '#14b8a6' },
  { bg: 'bg-indigo-100', text: 'text-indigo-800', border: 'border-indigo-200', ring: 'ring-indigo-300', dot: '#6366f1' },
  { bg: 'bg-pink-100', text: 'text-pink-800', border: 'border-pink-200', ring: 'ring-pink-300', dot: '#ec4899' },
];

const NEUTRAL = { bg: 'bg-zinc-100', text: 'text-zinc-500', border: 'border-zinc-200', ring: 'ring-zinc-200', dot: '#a1a1aa' };

// 標準カテゴリの固定色（floormap のピンでも同じ色になるように）
const FIXED = {
  'PC・ノートPC': 0,           // sky
  'サーバー': 1,                // violet
  'NAS・ストレージ': 2,          // emerald
  'ネットワーク機器': 10,        // indigo
  'モニター': 5,                // cyan
  'プリンター': 3,              // amber
  '周辺機器': 6,                // lime
  '電話・PBX': 7,               // fuchsia
  'ソフトウェア': 11,           // pink
  'ケーブル': 9,                // teal
  'ラック': 8,                  // orange
};

const hash = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return Math.abs(h);
};

export const categoryColor = (category) => {
  if (!category) return NEUTRAL;
  const key = String(category).trim();
  if (!key) return NEUTRAL;
  if (key in FIXED) return PALETTE[FIXED[key] % PALETTE.length];
  return PALETTE[hash(key) % PALETTE.length];
};

// 資産リスト用の小さい丸チップ + ラベル
export const CategoryChip = ({ category, className = '' }) => {
  if (!category) return <span className="text-zinc-300">—</span>;
  const c = categoryColor(category);
  return (
    <span
      data-testid="category-chip"
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[11px] font-medium whitespace-nowrap ${c.bg} ${c.text} ${c.border} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ backgroundColor: c.dot }} />
      {category}
    </span>
  );
};
